module.exports = __webpack_public_path__ + "img/globish-space-logo@3x.9e87e9da.png";